import { useMutation } from "@apollo/client";
import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageVCS } from "hooks/useAnalytics/pages/vcs";
import useTypedContext from "hooks/useTypedContext";

import { DELETE_ORIGIN_INTEGRATION } from "./gql";

const useDeleteOriginIntegration = () => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageVCS.VCSIntegrations,
  });

  const [originIntegrationDelete, { loading }] = useMutation(DELETE_ORIGIN_INTEGRATION, {
    refetchQueries: ["GetOriginBuiltInIntegration"],
    awaitRefetchQueries: true,
  });

  const deleteOriginIntegration = useCallback(
    (successCallback?: () => void) => {
      originIntegrationDelete()
        .then(({ data }) => {
          if (data?.originIntegrationDelete) {
            reportSuccess({ message: "Origin integration successfully deleted" });
            successCallback?.();

            trackSegmentAnalyticsEvent("Integration - Unlink Confirm", {
              integration: "Origin",
            });
          }
        })
        .catch(onError);
    },
    [originIntegrationDelete, onError, reportSuccess, trackSegmentAnalyticsEvent]
  );

  return { deleteOriginIntegration, loading };
};

export default useDeleteOriginIntegration;
